module.exports = __webpack_public_path__ + "img/import1.1d0fb805.svg";